/* Write-a-review dialog. See snippets/review-form.liquid for the design. */
(() => {
  const FLAG = 'rf:posted';
  const DRAFT = 'rf:draft';
  const LIMITS = { photo: { max: 3, bytes: 10 * 1024 * 1024 }, video: { max: 1, bytes: 80 * 1024 * 1024 } };

  class ReviewForm extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-rf-dialog]');
      this.form = this.querySelector('form');
      this.steps = [...this.querySelectorAll('[data-rf-step]')];
      this.order = this.steps.map((s) => s.dataset.rfStep).filter((n) => n !== 'done');
      this.foot = this.querySelector('[data-rf-foot]');
      this.backBtn = this.querySelector('[data-rf-back]');
      this.skipBtn = this.querySelector('[data-rf-skip]');
      this.nextBtn = this.querySelector('[data-rf-next]');
      this.submitBtn = this.querySelector('[data-rf-submit]');
      this.segs = [...this.querySelectorAll('.rf__seg')];
      this.ratingInput = this.querySelector('[data-rf-rating-input]');
      this.body = this.querySelector('[data-rf-body]');
      this.count = this.querySelector('[data-rf-count]');
      this.name = this.querySelector('[data-rf-name]');
      this.email = this.querySelector('[data-rf-email]');
      this.files = [];
      this.rating = 0;

      this.querySelectorAll('[data-rf-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });

      const stars = [...this.querySelectorAll('[data-rf-star]')];
      stars.forEach((s) => {
        const n = parseInt(s.dataset.rfStar, 10);
        s.addEventListener('mouseenter', () => stars.forEach((x) => x.classList.toggle('is-hover', parseInt(x.dataset.rfStar, 10) <= n)));
        s.addEventListener('mouseleave', () => stars.forEach((x) => x.classList.remove('is-hover')));
        s.addEventListener('click', () => { this.setRating(n); setTimeout(() => this.go(1), 220); });
      });
      this.stars = stars;

      if (this.body) {
        this.body.addEventListener('input', () => this.syncText());
      }
      [this.name, this.email].forEach((el) => el && el.addEventListener('input', () => this.syncWho()));

      this.backBtn.addEventListener('click', () => this.go(-1));
      this.skipBtn.addEventListener('click', () => this.go(1));
      this.nextBtn.addEventListener('click', () => this.go(1));

      this.querySelectorAll('[data-rf-file]').forEach((input) => {
        input.addEventListener('change', () => { this.addFiles(input.dataset.rfFile, [...input.files]); input.value = ''; });
      });

      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      const openers = document.querySelectorAll('[data-rf-open]');
      openers.forEach((b) => b.addEventListener('click', () => this.open('rating')));

      this.restoreAfterNavigation();
    }

    /* ---------- open, close, steps ---------- */

    open(step) {
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.show(step);
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    show(name) {
      this.current = name;
      this.steps.forEach((s) => { s.hidden = s.dataset.rfStep !== name; });
      const idx = this.order.indexOf(name);
      const done = name === 'done';
      this.foot.hidden = done;
      this.backBtn.hidden = idx <= 0;
      this.segs.forEach((seg, i) => seg.classList.toggle('is-on', i <= idx));
      this.skipBtn.hidden = name !== 'media';
      this.nextBtn.hidden = name !== 'text';
      this.submitBtn.hidden = name !== 'who';
      if (name === 'media') this.syncMedia();
      if (name === 'text') { this.syncText(); this.body && this.body.focus({ preventScroll: true }); }
      if (name === 'who') { this.syncWho(); this.name && this.name.focus({ preventScroll: true }); }
      const panel = this.steps.find((s) => s.dataset.rfStep === name);
      if (panel) panel.scrollTop = 0;
    }

    go(delta) {
      const idx = this.order.indexOf(this.current);
      const next = this.order[idx + delta];
      if (!next) return;
      if (delta > 0 && this.current === 'rating' && !this.rating) return;
      if (delta > 0 && this.current === 'text' && !this.textOk()) return;
      this.show(next);
    }

    setRating(n) {
      this.rating = n;
      this.ratingInput.value = String(n);
      this.stars.forEach((s) => {
        const on = parseInt(s.dataset.rfStar, 10) <= n;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', parseInt(s.dataset.rfStar, 10) === n ? 'true' : 'false');
      });
    }

    textOk() {
      return !!this.body && this.body.value.trim().length >= 1;
    }

    syncText() {
      if (!this.body) return;
      if (this.count) this.count.textContent = `${this.body.value.length} / ${this.body.maxLength}`;
      this.nextBtn.disabled = this.current === 'text' && !this.textOk();
    }

    syncWho() {
      const ok = this.name && this.email && this.name.value.trim() && this.email.checkValidity();
      this.submitBtn.disabled = !ok || this.uploading();
    }

    /* ---------- media ---------- */

    uploading() {
      return this.files.some((f) => f.state === 'uploading');
    }

    msg(text, alert) {
      const el = this.querySelector('[data-rf-media-msg]');
      if (!el) return;
      el.textContent = text || '';
      el.classList.toggle('is-alert', !!alert);
    }

    addFiles(kind, picked) {
      const limit = LIMITS[kind];
      const have = this.files.filter((f) => f.kind === kind && f.state !== 'failed').length;
      let room = limit.max - have;
      this.msg('');
      for (const file of picked) {
        if (room <= 0) { this.msg(kind === 'photo' ? 'Up to 3 photos.' : 'One video only.', true); break; }
        if (file.size > limit.bytes) { this.msg(`${file.name} is too big.`, true); continue; }
        room -= 1;
        const entry = { kind, file, state: 'uploading', url: '', pct: 0, el: null, xhr: null };
        this.files.push(entry);
        this.renderFile(entry);
        this.upload(entry);
      }
      this.syncMedia();
    }

    renderFile(entry) {
      const list = this.querySelector('[data-rf-files]');
      const li = document.createElement('li');
      li.className = 'rf__file';
      const src = URL.createObjectURL(entry.file);
      const media = entry.kind === 'video' ? document.createElement('video') : document.createElement('img');
      media.src = src;
      if (entry.kind === 'video') { media.muted = true; media.playsInline = true; }
      else media.alt = '';
      const bar = document.createElement('span');
      bar.className = 'rf__file-bar';
      bar.innerHTML = '<span></span>';
      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'rf__file-x';
      x.setAttribute('aria-label', 'Remove');
      x.textContent = '×';
      x.addEventListener('click', () => this.removeFile(entry));
      li.append(media, bar, x);
      list.appendChild(li);
      entry.el = li;
      entry.bar = bar.firstElementChild;
    }

    removeFile(entry) {
      if (entry.xhr) entry.xhr.abort();
      entry.el && entry.el.remove();
      this.files = this.files.filter((f) => f !== entry);
      this.syncMedia();
    }

    upload(entry) {
      const cloud = this.dataset.cloud;
      const preset = this.dataset.preset;
      const fd = new FormData();
      fd.append('file', entry.file);
      fd.append('upload_preset', preset);
      const xhr = new XMLHttpRequest();
      entry.xhr = xhr;
      xhr.open('POST', `https://api.cloudinary.com/v1_1/${encodeURIComponent(cloud)}/auto/upload`);
      xhr.upload.addEventListener('progress', (e) => {
        if (!e.lengthComputable) return;
        entry.pct = Math.round((e.loaded / e.total) * 100);
        entry.bar.style.width = `${entry.pct}%`;
      });
      xhr.addEventListener('load', () => {
        let url = '';
        try { url = JSON.parse(xhr.responseText).secure_url || ''; } catch (err) { url = ''; }
        if (xhr.status >= 200 && xhr.status < 300 && url) {
          entry.state = 'done';
          entry.url = url;
          entry.bar.style.width = '100%';
          entry.el.classList.add('is-done');
        } else {
          this.fail(entry);
        }
        this.syncMedia();
      });
      xhr.addEventListener('error', () => { this.fail(entry); this.syncMedia(); });
      xhr.addEventListener('abort', () => { entry.state = 'failed'; });
      xhr.send(fd);
    }

    fail(entry) {
      entry.state = 'failed';
      entry.el && entry.el.classList.add('is-failed');
      this.msg('That upload did not go through. Remove it and try again, or carry on without it.', true);
    }

    syncMedia() {
      const photos = this.querySelector('[data-rf-photos-input]');
      const video = this.querySelector('[data-rf-video-input]');
      if (photos) photos.value = this.files.filter((f) => f.kind === 'photo' && f.state === 'done').map((f) => f.url).join('\n');
      if (video) video.value = this.files.filter((f) => f.kind === 'video' && f.state === 'done').map((f) => f.url).join('\n');
      const busy = this.uploading();
      if (this.current === 'media') {
        const some = this.files.length > 0;
        this.skipBtn.hidden = some;
        this.nextBtn.hidden = !some;
        this.nextBtn.disabled = busy;
        if (busy) this.msg('Uploading.');
        else if (this.files.length && !this.files.some((f) => f.state === 'failed')) this.msg('Added.');
      }
      if (this.current === 'who') this.syncWho();
    }

    /* ---------- submit and return ---------- */

    onSubmit(e) {
      if (this.uploading() || !this.rating || !this.textOk()) { e.preventDefault(); return; }
      const draft = {
        rating: this.rating,
        body: this.body ? this.body.value : '',
        name: this.name ? this.name.value : '',
        email: this.email ? this.email.value : '',
        photos: this.files.filter((f) => f.kind === 'photo' && f.state === 'done').map((f) => f.url),
        video: this.files.filter((f) => f.kind === 'video' && f.state === 'done').map((f) => f.url),
      };
      try {
        sessionStorage.setItem(FLAG, '1');
        sessionStorage.setItem(DRAFT, JSON.stringify(draft));
      } catch (err) { /* private mode: the post still goes through */ }
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Posting';
    }

    restoreAfterNavigation() {
      let flagged = false;
      let draft = null;
      try {
        flagged = sessionStorage.getItem(FLAG) === '1';
        draft = JSON.parse(sessionStorage.getItem(DRAFT) || 'null');
      } catch (err) { flagged = false; }
      if (!flagged) return;

      const posted = this.hasAttribute('data-posted');
      const errored = !!this.querySelector('[data-rf-error]');
      if (!posted && !errored) return;

      try { sessionStorage.removeItem(FLAG); } catch (err) { /* nothing to clear */ }

      if (posted) {
        try { sessionStorage.removeItem(DRAFT); } catch (err) { /* nothing to clear */ }
        this.stripParam();
        this.open('done');
        return;
      }

      /* Shopify refused the post, usually the email. Put everything back and
         reopen on the step with the error. */
      if (draft) {
        this.setRating(draft.rating || 0);
        if (this.body) this.body.value = draft.body || '';
        if (this.name) this.name.value = draft.name || '';
        if (this.email) this.email.value = draft.email || '';
        const photos = this.querySelector('[data-rf-photos-input]');
        const video = this.querySelector('[data-rf-video-input]');
        if (photos) photos.value = (draft.photos || []).join('\n');
        if (video) video.value = (draft.video || []).join('\n');
      }
      const err = this.querySelector('[data-rf-error]');
      const who = this.steps.find((s) => s.dataset.rfStep === 'who');
      if (err && who) who.prepend(err);
      this.open('who');
    }

    stripParam() {
      try {
        const u = new URL(window.location.href);
        if (u.searchParams.has('contact_posted')) {
          u.searchParams.delete('contact_posted');
          u.hash = 'reviews';
          history.replaceState(null, '', u.toString());
        }
      } catch (err) { /* leave the address as it is */ }
    }
  }

  if (!customElements.get('review-form')) customElements.define('review-form', ReviewForm);
})();
